/* FIXEM - eslint-disable @typescript-eslint/no-unused-vars */
import { formatDistanceStrict, parseISO } from 'date-fns';
import ptBr from 'date-fns/locale/pt-BR';
import React, { useCallback, useEffect, useState } from 'react';
import ReactChatView from 'react-chatview';
import { CgClose } from 'react-icons/cg';
import { RiNotification4Fill } from 'react-icons/ri';
import logonoti from '~/assets/icons/logo-noti.svg';

import api from '~/services/api';
import { initializeNotificationSocketEvents } from '~/services/socket';

import { useAuthContext } from '~/hooks/contexts/Auth';
import { Button, Container } from './styles';

import CardNofitication from './CardNotification';

interface INotificationResponse {
  id: number;
  content: string;
  url?: string;
  read: boolean;
  created_at: string;
}

interface INotificationData {
  data: INotificationResponse[];
}

interface INotification {
  id: number;
  content: string;
  url?: string;
  read: boolean;
  date: string;
}

const Notifications: React.FC = () => {
  const { user } = useAuthContext();
  const [opened, setOpened] = useState(false);
  const [notifications, setNotifications] = useState<INotification[]>([]);
  const [newNotifications, setNewNotification] = useState(false);
  const [page, setPage] = useState(1);
  const [socketInitialized, setSocketInitialized] = useState(false);

  useEffect(() => {
    if (user!.id) {
      // initializeSocketConnection('notification', setSocketInitialized);
    }
  }, [user]);

  useEffect(() => {
    if (socketInitialized) {
      initializeNotificationSocketEvents({
        user_id: user!.id,
        opened,
        setNewNotification,
        setNotifications,
      });
    }
  }, [opened, socketInitialized, user]);

  const loadNotifications = useCallback(async () => {
    try {
      await api
        .get<INotificationData>(`builders/notifications/${user!.id}`)
        .then((response) => {
          const data = response.data.data.map((notification) => {
            const date = formatDistanceStrict(
              parseISO(notification.created_at),
              new Date(),
              {
                addSuffix: true,
                locale: ptBr,
              }
            );
            return {
              id: notification.id,
              content: notification.content,
              url: notification.url,
              read: notification.read,
              date,
            };
          });

          setNotifications(data);
        });
    } catch {
      // Swal.fire({
      //   icon: 'error',
      //   title: 'Ocorreu um erro ao carregar notificações, tente novamente',
      // });
    }
  }, [user]);

  const handleCheckReadNotification = useCallback(() => {
    api
      .get<INotificationData>(`builders/notifications/${user!.id}`)
      .then((response) => {
        const data = response.data.data.map((notification) => {
          const date = formatDistanceStrict(
            parseISO(notification.created_at),
            new Date(),
            {
              addSuffix: true,
              locale: ptBr,
            }
          );
          return {
            id: notification.id,
            content: notification.content,
            url: notification.url,
            read: notification.read,
            date,
          };
        });

        const checkNotification = data.find(
          (notification) => !notification.read
        );

        if (checkNotification) {
          setNewNotification(true);
        }

        setNotifications(data);
      });
  }, [user]);

  useEffect(() => {
    handleCheckReadNotification();
  }, [handleCheckReadNotification, user!.id]);

  const loadOldNotifications = useCallback(async () => {
    try {
      const newPage = page + 1;
      const response = await api.get<INotificationData>(
        `builders/notifications/${user!.id}`,
        {
          params: {
            page: newPage,
          },
        }
      );

      const data: INotification[] = response.data.data.map((notification) => {
        const date = formatDistanceStrict(
          parseISO(notification.created_at),
          new Date(),
          {
            addSuffix: true,
            locale: ptBr,
          }
        );
        return {
          id: notification.id,
          content: notification.content,
          url: notification.url,
          read: notification.read,
          date,
        };
      });
      setNotifications((state) => [...state, ...data]);
      setPage(newPage);
    } catch {
      // Swal.fire({
      //   icon: 'error',
      //   title: 'Ocorreu um erro ao carregar notificações, tente novamente',
      // });
    }
  }, [page, user]);

  const handleReadNotification = useCallback(
    async (notification: INotification) => {
      try {
        await api.put(`builders/notifications/${notification.id}`, {
          read: true,
          url: notification.url,
          content: notification.content,
        });
      } catch {
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Ocorreu um erro ao carregar notificações, tente novamente',
        // });
      }
    },
    []
  );

  const handleSetReadNotification = useCallback(
    (data: INotification[]) => {
      data.map((noticationIS) =>
        Number(noticationIS.read) !== 1
          ? handleReadNotification(noticationIS)
          : ''
      );
    },
    [handleReadNotification]
  );

  const handleClose = useCallback(() => {
    handleSetReadNotification(notifications);
    setOpened(false);
    loadNotifications();
    setNewNotification(false);
  }, [handleSetReadNotification, loadNotifications, notifications]);

  return (
    <>
      <Button
        type="button"
        className="border-0 bg-transparent"
        onClick={() => setOpened(true)}
        new={newNotifications}
      >
        <span style={{ backgroundColor: '#fcfcfc' }}>
          <RiNotification4Fill size={27} color="#707070" />
        </span>
      </Button>
      <Container
        opened={opened}
        className="position-fixed d-flex justify-content-end"
      >
        <button type="button" onClick={handleClose} />
        <ReactChatView
          className="bg-white p-4"
          scrollLoadThreshold={100}
          onInfiniteLoad={loadOldNotifications}
        >
          <button
            type="button"
            className="d-block border-0 bg-transparent ms-auto mb-4"
            onClick={handleClose}
          >
            <CgClose size={20} color="#949494" />
          </button>
          <h4>
            Notificações
            <span className="d-inline-block ms-2">
              <RiNotification4Fill size={23} color="#414142" />
            </span>
          </h4>
          <div className="box-notificattions mt-4">
            {notifications.map((notification) => (
              <CardNofitication
                key={notification.id}
                id={notification.id}
                date={notification.date}
                content={notification.content}
                url={notification.url}
                read={notification.read}
              />
            ))}
          </div>
          <div className="d-flex justify-content-center mt-5">
            <img src={logonoti} alt="logonoti" color="#707070" id="Iconrojo" />
          </div>
        </ReactChatView>
      </Container>
    </>
  );
};

export default Notifications;
